import { dispatch } from '../utils/generalUtils';
import { LOGIN_USER, LOGOUT } from '../constants/actions';

export function saveUserData(userData) {
    dispatch({
        type: LOGIN_USER,
        userData
    });
}

export function logoutUser() {
    return dispatch({
        type: LOGOUT
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/loginActions.ts